import {Component, Inject} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {RequestMedicineService} from "../../../services/common/request-medicine.service";
import {UserDataService} from "../../../services/common/user-data.service";
import {DivisionService} from "../../../services/common/division.service";
import {ZoneService} from "../../../services/common/zone.service";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {UiService} from "../../../services/core/ui.service";
import {Area} from "../../../interfaces/common/area.interface";
import {Division} from "../../../interfaces/common/division.interface";
import {AreaService} from "../../../services/common/area.service";
import {Subscription} from "rxjs";
import {ReloadService} from "../../../services/core/reload.service";
import {RequestMedicine} from "../../../interfaces/common/request-medicine";
import {Zone} from "../../../interfaces/common/zone.interface";
import {FilterData} from "../../../interfaces/core/filter-data";
import {UtilsService} from "../../../services/core/utils.service";
import {FileUploadService} from "../../../services/gallery/file-upload.service";
import {User} from '../../../interfaces/common/user.interface';
import {Address} from '../../../interfaces/common/address.interface';

@Component({
  selector: 'app-request-medicine',
  templateUrl: './request-medicine.component.html',
  styleUrls: ['./request-medicine.component.scss']
})
export class RequestMedicineComponent {
//Store Data
  dataForm: FormGroup;

  divisions: Division[] = [];
  area: Area[] = [];
  zone: Zone[] = [];
  isLoading = false;
  //Files
  files: File[] = [];
  oldImages: string[] = [];
  fileNotPicked: boolean = false;
  medicineDataArray?: FormArray;
  user: User;
  addresses: Address[];
  selectEdittedAdress: Address | any = null;
  getDefaultAdress: Address | any = null;
//Subscriptions
  private subDivisionData: Subscription;
  private subAreaData: Subscription;
  private subZoneData: Subscription;
  private subForm: Subscription;
  private subUpdateAddress: Subscription;
  private subDeleteAddress: Subscription;
  private subDataOne: Subscription;
  private subGetData4: Subscription;

  constructor(
    private fb: FormBuilder,
    private uiService: UiService,
    private divisionService: DivisionService,
    private areaService: AreaService,
    private zoneService: ZoneService,
    private userDataService: UserDataService,
    private reloadService: ReloadService,
    private requestMedicineService:RequestMedicineService,
    private dialog: MatDialog,
    private utilsService: UtilsService,
    private fileUploadService: FileUploadService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.intiForm();


    this.getLoggedInUserInfo()
    this.getUserAddress()
    this.getAllDivision();
  }

  /**
   * initialize function
   * intiForm()
   * onFormSubmit()
   */
  intiForm() {
    this.dataForm = this.fb.group({
      name: [null, Validators.required],
      phoneNo: [null, [Validators.required,Validators.maxLength(11)]],
      division: [null, Validators.required],
      area: [null, Validators.required],
      zone: [null],
      genericName: [null],
      orderNotes: [null, [Validators.required]],
      medicineInfo: this.fb.array([]),
      images: [null],
    });

    this.medicineDataArray = this.dataForm.get(
      'medicineInfo'
    ) as FormArray;
  }


  /**
   * FORM DATA SUBMIT FUNCTION
   * onFormSubmit()
   * patchData()
   */
  onFormSubmit() {
    if (this.dataForm.valid) {
      let selectDivision = this.divisions.find((d) => d._id === this.dataForm.value.division);
      let selectArea = this.area.find((d) => d._id === this.dataForm.value.area);
      let selectZone = this.zone.find((d) => d._id === this.dataForm.value.zone);
      const mData = {
        ...this.dataForm.value,
        ...{ division: selectDivision },
        ...{ area: selectArea },
        ...{ zone: selectZone },
        ...{checkoutDate: this.utilsService.getDateString(new Date()),}
      }
      if (this.files.length) {
        this.uploadImageServer(mData)
      } else {
        this.addRequestMedicine(mData);
      }

    }
    else {
      this.uiService.warn('Please fill all form input');
      this.dataForm.markAllAsTouched();
    }
  }


  onAddNewMedicineInfo() {
    const f = this.fb.group({
      name: [null],
      value: [null],
      genericName: [null],
    });
    (this.dataForm?.get('medicineInfo') as FormArray).push(f);
  }

  removeFeaturesFormArrayField(formControl: string, index: number) {
    let formDataArray: FormArray;
    switch (formControl) {
      case 'medicineInfo': {
        formDataArray = this.medicineDataArray;
        break;
      }

      default: {
        formDataArray = null;
        break;
      }
    }
    formDataArray?.removeAt(index);
  }


  /***
   * HTTP REQUEST HANDLE
   * getAllDivision()
   * getAllArea()
   * getAllZone()
   * addAddress()
   * getUserAddress()
   *
   */

  private getUserAddress() {
    this.subGetData4 = this.userDataService.getUserAddress().subscribe({
        next: res => {
          if (res.success) {
            this.addresses = res.data;

            this.getDefaultAdress  = this.addresses.find(f => f.setDefaultAddress === true);
            this.dataForm.patchValue({ division: this.getDefaultAdress?.division?._id });
            this.dataForm.patchValue({ area: this.getDefaultAdress?.area?._id });
            this.dataForm.patchValue({ zone: this.getDefaultAdress?.zone?._id });
            this.getAllArea(this.dataForm.get('division')?.value);
            this.getAllZone(this.dataForm.get('area')?.value);
          }
        },
        error: err => {
          console.log(err);
        }
      }
    )
  }


  private getLoggedInUserInfo() {
    this.subGetData4 = this.userDataService.getLoggedInUserData()
      .subscribe({
        next: res => {
          if (res) {
            this.user = res.data;
            this.dataForm.patchValue(this.user);
            this.dataForm.patchValue({phone: this.user?.phoneNo});

            this.dataForm.patchValue({ division: this.user?.division?._id });
            this.dataForm.patchValue({ area: this.user?.area?._id });
            this.dataForm.patchValue({ zone: this.user?.zone?._id });
            this.getAllArea(this.dataForm.get('division')?.value);
            this.getAllZone(this.dataForm.get('area')?.value);

          }
        },
        error: err => {
          console.log(err);
        }
      });
  }


  private getAllDivision() {
    let mSelect = {
      name: 1,
    }
    const filter: FilterData = {
      filter: { status: 'publish' },
      select: mSelect,
      pagination: null,
      sort: { createdAt: -1 }
    }

    this.subDivisionData = this.divisionService.getAllDivisions(filter).subscribe(
      (res) => {
        if (res.success) {
          this.divisions = res.data;
        }
      },
      (err) => {
        if (err) {
          console.log(err);
        }
      }
    )
  }

  private getAllArea(id: string) {
    const select = 'name';
    this.subAreaData = this.areaService.getAreaByParentId(id, select).subscribe(
      (res) => {
        if (res.success) {
          this.area = res.data;
        }
      },
      (err) => {
        if (err) {
          console.log(err);
        }
      }
    )
  }


  private getAllZone(id: string) {
    const select = 'name';
    this.subZoneData = this.zoneService.getZoneByParentId(id, select).subscribe(
      (res) => {
        if (res.success) {
          this.zone = res.data;
        }
      },
      (err) => {
        if (err) {
          console.log(err);
        }
      }
    )
  }

  private addRequestMedicine(data: RequestMedicine) {
    this.isLoading = true;
    this.subForm = this.requestMedicineService.addRequestMedicine(data).subscribe((res) => {
        if (res) {
          this.isLoading = false;
          this.files = [];
          this.uiService.success('Request Added');
          this.reloadService.needRefreshData$();
          this.dialog.closeAll();
        }
      },
      (err) => {
        if (err) {
          this.isLoading = false;
          console.log(err);
        }
      }
    )
  }

  /**
   * IMAGE DRUG & DROP
   */
  onSelect(event: any[]) {
    this.files = event;
    this.fileNotPicked = false;
  }

  onDeleteOldImage(event: any) {
    this.oldImages = event;
  }


  /***
   * FILE UPLOAD FUNCTIONALITY
   * uploadFile()
   */

  uploadImageServer(data: any) {
    this.subDataOne = this.fileUploadService.uploadMultiImageOriginal(this.files)
      .subscribe({
        next: res => {
          const images = res.map((d) => d.url);
          const finalData = {
            ...data,
            ...{
              images: images
            }
          };
            this.addRequestMedicine(finalData);
        },
        error: err => {
          this.isLoading = false;
          this.uiService.wrong('Failed! Upload Image Failed, Try again.');
          console.log(err);
        }
      })

  }

  /***
   * ON SELECT CHANGE
   * onChangeRegion()
   * onChangeArea()
   */
  onChangeRegion(event: any) {
    if (event) {
      this.getAllArea(event?._id);
      this.dataForm.get('division')?.patchValue(event?._id);
    }
  }

  onChangeArea(event: any) {
    if (event) {
      this.getAllZone(event?._id);
      this.dataForm.get('area')?.patchValue(event?._id);
    }
  }

  onChangeZone(event: any) {
    if (event) {
      this.dataForm.get('zone')?.patchValue(event?._id);
    }
  }


  onClose(){
    this.dialog.closeAll();
  }
  /***
   * NG ON DESTROY
   */
  ngOnDestroy(): void {
    if (this.subAreaData) {
      this.subAreaData.unsubscribe();
    }
    if (this.subDivisionData) {
      this.subDivisionData.unsubscribe();
    }
    if (this.subForm) {
      this.subForm.unsubscribe();
    }
    if (this.subZoneData) {
      this.subZoneData.unsubscribe();
    }
    if (this.subUpdateAddress) {
      this.subUpdateAddress.unsubscribe();
    }
    if (this.subDeleteAddress) {
      this.subDeleteAddress.unsubscribe();
    }
  }
}
